module.exports = __webpack_public_path__ + "img/20190808171934942.b06a87e9.png";